export enum APIEnviroments {
    Development = 'http://localhost:53555/',
    LocalServer = 'http://192.168.43.227/',
    Azure = 'https://autoexpert.azurewebsites.net/',
    Test_Azure = 'https://autoexpert-test.azurewebsites.net/',
    ShiftGodaddy = 'https://autoexpert.shift.software/'
}